import React, { useState } from "react";

import { useGlobalContext } from "./context/globalContext";
import { Carousel } from "react-bootstrap";

const Hero = () => {
  const { handleShowModal } = useGlobalContext();
  const [index, setIndex] = useState(0);

  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
  };
  return (
    <div id="home" className="section" style={{ padding: "0" }}>
      <div className="desktopview">
        {/* <img
          onClick={handleShowModal}
          height="100%"
          width="100%"
          className="d-block micro-main-slider-img ls-is-cached lazyloaded"
          src="images/web-banner.png"
          alt="banner"
        /> */}
        <Carousel
          slide="true"
          interval="2000"
          activeIndex={index}
          onSelect={handleSelect}
          nextLabel=""
          prevLabel=""
          nextIcon=">>"
          prevIcon="<<"
          touch="true"
        >
          <Carousel.Item>
            <img
              onClick={() => handleShowModal("Web Banner")}
              height="100%"
              width="100%"
              className="d-block micro-main-slider-img ls-is-cached lazyloaded"
              src="images/web-banner-2.png"
              alt="banner"
            />
          </Carousel.Item>
          <Carousel.Item>
            <img
              onClick={() => handleShowModal("Web Banner")}
              height="100%"
              width="100%"
              className="d-block micro-main-slider-img ls-is-cached lazyloaded"
              src="images/web-banner-1.png"
              alt="banner"
            />
          </Carousel.Item>
        </Carousel>
      </div>
      <div className="mobileview">
        {/* <img
          onClick={handleShowModal}
          height="100%"
          width="100%"
          className="d-block micro-main-slider-img ls-is-cached lazyloaded"
          src="images/mob-banner.png"
          alt="banner"
        /> */}
        <Carousel
          slide="true"
          interval="2500"
          activeIndex={index}
          onSelect={handleSelect}
          nextLabel=""
          prevLabel=""
          nextIcon=">>"
          prevIcon="<<"
          touch="true"
        >
          <Carousel.Item>
            <img
              onClick={() => handleShowModal("Mob Banner")}
              height="100%"
              width="100%"
              className="d-block micro-main-slider-img ls-is-cached lazyloaded"
              src="images/mobile-banner-2.png"
              alt="banner"
            />
          </Carousel.Item>
          <Carousel.Item>
            <img
              onClick={() => handleShowModal("Mob Banner")}
              height="100%"
              width="100%"
              className="d-block micro-main-slider-img ls-is-cached lazyloaded"
              src="images/mobile-banner-1.png"
              alt="banner"
            />
          </Carousel.Item>
        </Carousel>
      </div>
    </div>
  );
};

export default Hero;
